// extracted by css-extract-rspack-plugin
export default {"unreadBorder":"UnreadBorder-module__unreadBorder__ri0jR"};